// src/pages/AtaualzacaoCadastral.js
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import React from 'react';
import AttCadastral from '../components/AttCadastral';

const AtualizacaoCadastral = () => {
    return (
        <>
            <div className="main-content">
                <Navbar />
            </div>
            <div className="content">
                <Sidebar />
            </div>
            <div className='att-register'>
                <AttCadastral />
            </div>
        </>
    );
};

export default AtualizacaoCadastral;
